module.exports = __webpack_public_path__ + "pdk0-63.jpg?8227c7bfacd43401fb83bc9cca6ec97f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pdk0-63.jpg
// module id = 75
// module chunks = 0